/**
 * OrderBy Class
 *
 */
export default class OrderBy {


    // constructor
    constructor(selector, submitOnChange = true) {
        this.$plugin = $(selector);
        this.$currentSorting = this.$plugin.find('[data-tncp-orderby-value]');
        this.submitOnChange = submitOnChange;
        this.execute();
    }


    // execute
    execute() {
        let vm = this;
        if (vm.$plugin.length > 0) {

            // event handler for click on sorting icon
            vm.$plugin.on('click', '[data-tncp-orderby-field]', function() {
                const $clickedElement = $(this);

                // data attributes
                let dataAttributes = vm.getDataAttributes($clickedElement);

                // if clicked sorting button is not self / active
                // else just invert asc / desc
                if (dataAttributes.active === 'true') {
                    dataAttributes.direction = vm.invertDirection(dataAttributes.direction);
                    $clickedElement.attr('data-tncp-orderby-direction', dataAttributes.direction);
                } else {
                    vm.$plugin.find('[data-tncp-orderby-active="true"]').removeAttr('data-tncp-orderby-active');
                    $clickedElement.attr('data-tncp-orderby-active', true);
                }

                // change sorting and save it to hidden field
                let sortValue = dataAttributes.field + ' ' + dataAttributes.direction;
                vm.$plugin.find('[data-tncp-orderby-value]').val(sortValue);

                // if submitOnChange is true, then submit the form
                if (vm.submitOnChange) {
                    let $submitForm = vm.$plugin.find('form[data-tncp-orderby-submit-form]');
                    if($submitForm.length > 0) {
                        $submitForm.submit();
                    }else {
                        vm.$plugin.find('form').first().submit();
                    }
                }
            });

        }
    }


    /**
     * get the data attributes of the clicked element
     *
     * @param $clickedElement
     * @returns {{active, direction, field}}
     */
    getDataAttributes($clickedElement) {
        return {
            active: $clickedElement.attr('data-tncp-orderby-active'),
            direction: $clickedElement.attr('data-tncp-orderby-direction'),
            field: $clickedElement.attr('data-tncp-orderby-field')
        }
    }


    /**
     * invert the direction
     *
     * @param direction
     * @returns {*}
     */
    invertDirection(direction) {
        if (direction === 'asc') {
            direction = 'desc'
        } else {
            direction = 'asc';
        }
        return direction;
    }

}

